import ScalarIconArrowElbowDownLeft_vue_vue_type_script_setup_true_lang_default from "./ScalarIconArrowElbowDownLeft.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconArrowElbowDownLeft.vue
var ScalarIconArrowElbowDownLeft_default = ScalarIconArrowElbowDownLeft_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconArrowElbowDownLeft_default as default };

//# sourceMappingURL=ScalarIconArrowElbowDownLeft.js.map